const permission = {
  canManageGrants: function(accountId, permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 && p.Permission.Permission_Id == 2
      )
    ) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 && p.Permission.Permission_Id == 3
      )
    ) {
      return true;
    }

    return false;
  },

  canAddNewGrants: function(organization, permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 && p.Permission.Permission_Id == 3
      )
    ) {
      return true;
    }
    if (permissions.find(p => p.Permission.Permission_Id == 4)) {
      return true;
    }

    return false;
  },

  canApproveGrants: function(permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }

    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 && p.Permission.Permission_Id == 2
      )
    ) {
      return true;
    }

    return false;
  },

  canManageBlog: function(permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 &&
          p.Permission.Permission_Id == 12
      )
    ) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 &&
          p.Permission.Permission_Id == 13
      )
    ) {
      return true;
    }

    return false;
  },

  canAddBlogPost: function(permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }

    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 &&
          p.Permission.Permission_Id == 12
      )
    ) {
      return true;
    }

    return false;
  },

  canApproveBlogPost: function(permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }

    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == 1 &&
          p.Permission.Permission_Id == 13
      )
    ) {
      return true;
    }

    return false;
  },

  canManageAllAccounts: function(accountId, permissions) {
    if (accountId != 1) {
      return false;
    }
    if (
      permissions.find(p => p.Permission.Permission_Id == 1) ||
      permissions.find(p => p.Permission.Permission_Id == 5)
    ) {
      return true;
    }
    return false;
  },

  canManageMyAccount: function(permissions) {
    if (
      permissions.find(p => p.Permission.Permission_Id == 1) ||
      permissions.find(
        p =>
          p.Organization.Organization_Id ==
            this.$store.getters.user.Organization_Id &&
          p.Permission.Permission_Id == 5
      )
    ) {
      return true;
    }
    return false;
  },

  canManageTemplates: function(permissions) {
    if (permissions.find(p => p.Permission.Permission_Id == 1)) {
      return true;
    }
    if (permissions.find(p => p.Permission.Permission_Id == 6)) {
      return true;
    }
    return false;
  },

  canManageOrganization: function(organizationId, permissions) {
    if (
      this.$canManageAllAccounts(permissions) ||
      this.$canManageMyAccount(permissions)
    ) {
      return true;
    }
    if (
      permissions.find(
        p =>
          p.Organization.Organization_Id == organizationId &&
          p.Permission.Permission_Id == 7
      )
    ) {
      return true;
    }
    return false;
  },

  getAllPermissions: async function() {
    var query = `{
        permissions {
          Permission_Id
          Title
        }
      }`;
    return await this.$store.getters.fetcher({ query }).then(r => {
      return r.data.permissions;
    });
  },

  addPermissions: async function(permissions, userId) {
    const query = `
    mutation($permissions: [UserPermissionInput], $userId: Int!) {
      AddPermissions(permissions: $permissions, userId: $userId) {
        UserPermission_Id
        Organization{
          Organization_Id
          Name
        }
        Permission{
          Permission_Id
          Title
        }
      }
    }`;
    const variables = {
      permissions: permissions,
      userId: userId
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      return r.data.AddPermissions;
    });
  },

  removePermissions: async function(permissions, userId) {
    const query = `
    mutation($permissions: [Int], $userId: Int!) {
      RemovePermissions(permissions: $permissions, userId: $userId) {
        UserPermission_Id
        Organization{
          Organization_Id
          Name
        }
        Permission{
          Permission_Id
          Title
        }
      }
    }`;
    const variables = {
      permissions: permissions,
      userId: userId
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      return r.data.RemovePermissions;
    });
  }
};

export { permission };
